import {useState, useEffect} from 'react';
import { toast } from 'react-toastify';

import Helmet from '../components/Helmet/Helmet';

import { Container, Row } from 'reactstrap';

import ProductsList from '../components/UI/ProductsList';

import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase.config';

import '../styles/home.css';
import VideoCarousel from '../components/Carousel/VideoCarousel';

const Home = () => {

    const [data, setData] = useState();
    const [loading, setLoading] = useState(true);
    const [videoLoading, setVideoLoading] = useState(true);
    const [videoSrc, setVideoSrc] = useState("");

    const videoData = [
        {
            id: 1,
            name: "BASS LOGO ANIMATION",
            url: "https://firebasestorage.googleapis.com/v0/b/the-vision-745ff.appspot.com/o/static-media-home%2Fhero-draft.mp4?alt=media&token=6189ca51-5b74-4473-a138-9e2b195322c3",
            thumbnail: "https://firebasestorage.googleapis.com/v0/b/the-vision-745ff.appspot.com/o/static-media-home%2FBASSLOGO.png?alt=media&token=77c5e08b-56c0-4573-8f9c-2b8f96cf7fde",
            thumbnailVideo: "https://firebasestorage.googleapis.com/v0/b/the-vision-745ff.appspot.com/o/static-media-home%2FBASSLOGO.png?alt=media&token=77c5e08b-56c0-4573-8f9c-2b8f96cf7fde",
            loop: true,
            muted: true
        },
        {
            id: 2,
            name: "BOOTS LOGO ANIMATION",
            url: "https://firebasestorage.googleapis.com/v0/b/the-vision-745ff.appspot.com/o/static-media-home%2Fhomescreenex.mp4?alt=media&token=babe5b0a-6c48-479e-98d0-1cc98617cf4c",
            thumbnail: "https://firebasestorage.googleapis.com/v0/b/the-vision-745ff.appspot.com/o/static-media-home%2FBOOTSLOGO.png?alt=media&token=24fd7e52-77ba-4da2-89e9-eede9756cf85",
            thumbnailVideo: "https://firebasestorage.googleapis.com/v0/b/the-vision-745ff.appspot.com/o/static-media-home%2Fhomescreenex.mp4?alt=media&token=babe5b0a-6c48-479e-98d0-1cc98617cf4c",
            loop: true,
            muted: true
        },
        {
            id: 3,
            name: "Shipping",
            url: "https://firebasestorage.googleapis.com/v0/b/the-vision-745ff.appspot.com/o/static-media-home%2FGARMENTS%20INTRO%205.mp4?alt=media&token=34177c20-e313-4bef-b0a7-9af869008c7b",
            thumbnail: "https://firebasestorage.googleapis.com/v0/b/the-vision-745ff.appspot.com/o/static-media-home%2Fshippingstamp1.png?alt=media&token=77e0cc4b-a3b6-4553-ae90-c24b51bbb6d1",
            thumbnailVideo: "https://firebasestorage.googleapis.com/v0/b/the-vision-745ff.appspot.com/o/static-media-home%2FshippinglabelVIDEO.mp4?alt=media&token=56fa84f8-bf21-4d61-91e2-9938f9230b20",
            loop: true,
            muted: true
        },
        {
            id: 4,
            url: "https://firebasestorage.googleapis.com/v0/b/the-vision-745ff.appspot.com/o/static-media-home%2Fhero-draft.mp4?alt=media&token=6189ca51-5b74-4473-a138-9e2b195322c3",
            thumbnail: "https://firebasestorage.googleapis.com/v0/b/the-vision-745ff.appspot.com/o/static-media-home%2FPFF2.png?alt=media&token=5b258549-3e00-4fa0-b049-eda5164677f6",
            thumbnailVideo: "https://firebasestorage.googleapis.com/v0/b/the-vision-745ff.appspot.com/o/static-media-home%2Fhero-draft.mp4?alt=media&token=6189ca51-5b74-4473-a138-9e2b195322c3",
            loop: true,
            muted: true
        },
        {
            id: 5,
            url: "https://firebasestorage.googleapis.com/v0/b/the-vision-745ff.appspot.com/o/static-media-home%2Fhomescreenex.mp4?alt=media&token=babe5b0a-6c48-479e-98d0-1cc98617cf4c",
            thumbnail: "https://firebasestorage.googleapis.com/v0/b/the-vision-745ff.appspot.com/o/static-media-home%2FPFF2.png?alt=media&token=5b258549-3e00-4fa0-b049-eda5164677f6",
            thumbnailVideo: "https://firebasestorage.googleapis.com/v0/b/the-vision-745ff.appspot.com/o/static-media-home%2Fhomescreenex.mp4?alt=media&token=babe5b0a-6c48-479e-98d0-1cc98617cf4c",
            loop: true,
            muted: true
        },
        {
            id: 6,
            url: "https://firebasestorage.googleapis.com/v0/b/the-vision-745ff.appspot.com/o/static-media-home%2FGARMENTS%20INTRO%205.mp4?alt=media&token=34177c20-e313-4bef-b0a7-9af869008c7b",
            thumbnail: "https://firebasestorage.googleapis.com/v0/b/the-vision-745ff.appspot.com/o/static-media-home%2FPFF2.png?alt=media&token=5b258549-3e00-4fa0-b049-eda5164677f6",
            thumbnailVideo: "https://firebasestorage.googleapis.com/v0/b/the-vision-745ff.appspot.com/o/static-media-home%2FGARMENTS%20INTRO%205.mp4?alt=media&token=34177c20-e313-4bef-b0a7-9af869008c7b",
            loop: true,
            muted: true
        },
        {
            id: 7,
            url: "https://firebasestorage.googleapis.com/v0/b/the-vision-745ff.appspot.com/o/static-media-home%2FGARMENTS%20INTRO%205.mp4?alt=media&token=34177c20-e313-4bef-b0a7-9af869008c7b",
            thumbnail: "https://firebasestorage.googleapis.com/v0/b/the-vision-745ff.appspot.com/o/static-media-home%2FPFF2.png?alt=media&token=5b258549-3e00-4fa0-b049-eda5164677f6",
            thumbnailVideo: "https://firebasestorage.googleapis.com/v0/b/the-vision-745ff.appspot.com/o/static-media-home%2FGARMENTS%20INTRO%205.mp4?alt=media&token=34177c20-e313-4bef-b0a7-9af869008c7b",
            loop: true,
            muted: true
        },
        // Add more videos...
    ];

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, "products"));
                const productsList = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                const filteredProducts = productsList.filter(item => item.category === 'Physical');
    
                // Define category order
                const categoryOrder = {
                    tshirts: 1,
                    hoodies: 2,
                    pants: 3,
                    rugs: 4,
                    accessories: 5
                };
    
                // Sort by category, then by premium status (true first)
                const sortedProducts = filteredProducts.sort((a, b) => {
                    const categoryComparison = categoryOrder[a.productCategory] - categoryOrder[b.productCategory];
    
                    if (categoryComparison !== 0) return categoryComparison;
    
                    // Same category — sort by isPremium (true first)
                    return (b.isPremium === true) - (a.isPremium === true);
                });
    
                setData(sortedProducts);
            } catch (error) {
                toast.error("Error fetching products: ", error.message);
            } finally {
                setLoading(false);
            }
        };
    
        fetchProducts();
    }, []);

    useEffect(() => {
        const width = window.innerWidth;
            if (width >= 1025) {
            setVideoSrc("https://firebasestorage.googleapis.com/v0/b/the-vision-745ff.appspot.com/o/static-media-home%2FGARMENTS%20INTRO%205.mp4?alt=media&token=34177c20-e313-4bef-b0a7-9af869008c7b");
        } else {
            setVideoSrc("https://firebasestorage.googleapis.com/v0/b/the-vision-745ff.appspot.com/o/static-media-home%2FMOBILEVIDVERSION1_1_1_1_1_1_1_1_1_1_1.mp4?alt=media&token=d58730c0-1646-41be-9b0c-23d26bc9c93d");
        }
    }, []);
    

    const textContent = 'Gallery of the Future.';
    const textContent2 = 'مستقبل الموضة';
    
    const textElements = [];
    for (let i = 0; i < 30; i++) {
        if (i % 3 === 0 && i !== 0){
            textElements.push(
                <span key={i} className="text-content">
                    {textContent2}
                </span>
        );}
        else {
            textElements.push(
                <span key={i} className="text-content">
                    {textContent}
                </span>
        );}
    }

    const mirroredTextElements = [];
    for (let i = 0; i < 20; i++) {
        if (i % 3 === 0 && i !== 0){
            mirroredTextElements.push(
                <span key={i} className="text-content mirror">
                    {textContent2}
                </span>
        );}
        else {
            mirroredTextElements.push(
                <span key={i} className="text-content mirror">
                    {textContent}
                </span>
        );}
    }

    return (
        <Helmet title="Home" description="The fashion gallery of the future">
            <section>
                <Container style={{padding: 0}}>
                    <VideoCarousel videos={videoData} />
                </Container>
            </section>

            <section id='#products' className='section'>
                <Container>
                    <Row className='gallery'>
                        {loading && <div> Loading Products... </div>}
                        <ProductsList data={data} />
                    </Row>
                </Container>
            </section>
        </Helmet>
    );
};

export default Home;
